import { Injectable } from "@angular/core";

export interface FileServiceConfig {
  restServer: string;
}

export interface ContextData {
  id?: number;
  name: string;
  description?: string;
  uri?: string;
  file?: StoredFile;
  file_id?: number;
}

export interface StoredFileData {
  id?: number;
  name: string;
  filename?: string;
  file_id?: number;
  file?: number;
  sds_filetype_id?: number;
  file_type?: string;
  created?: string;
  size?: number;
  url?: string;
  assay_ids?: number[];
}

export interface StoredFile {
  id?: number;
  filename: string;
  service?: string;
  created?: string;
  updated?: string;
  file_last_modified?: string;
  size: number;
  file_data?: StoredFileData;
  assay_count?: number;
  uploaded_by_name?: string;
  filetype_id?: number;
  sds_filetype_id?: number;
  uploaded_by_email?: string;
}

export interface UploadFile {
  file: File;
  storedFile?: StoredFile;
  uniqueFileName: string;
  uploadUrl: string;
  contentType: string;
}

@Injectable({
  providedIn: 'root',
})

export class FileServiceTypes {

}